const mainAlert = (state = {}, action) => {
    switch (action.type) {
        case "SET_MAIN_ALERT":
            return action.payload
        default:
            return state
    }
}

export default mainAlert;